export default __webpack_public_path__ + "static/media/dos-check.32a864d0.svg";